import { render } from "./dol-upload-img.vue?vue&type=template&id=3130c51a"
import script from "./dol-upload-img.vue?vue&type=script&lang=js"
export * from "./dol-upload-img.vue?vue&type=script&lang=js"

import "./dol-upload-img.vue?vue&type=style&index=0&id=3130c51a&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__